import { render, staticRenderFns } from "./SkuCatalog.vue?vue&type=template&id=2eda18fb&scoped=true&"
import script from "./SkuCatalog.vue?vue&type=script&lang=js&"
export * from "./SkuCatalog.vue?vue&type=script&lang=js&"
import style0 from "./SkuCatalog.vue?vue&type=style&index=0&id=2eda18fb&scoped=true&lang=css&"
import style1 from "./SkuCatalog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eda18fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eda18fb')) {
      api.createRecord('2eda18fb', component.options)
    } else {
      api.reload('2eda18fb', component.options)
    }
    module.hot.accept("./SkuCatalog.vue?vue&type=template&id=2eda18fb&scoped=true&", function () {
      api.rerender('2eda18fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/SkuCatalog.vue"
export default component.exports